import React, {useMemo} from 'react';
import {FullTextSearchPogisQuery} from 'features/Search/hooks';
import {SearchResultPOGIS} from 'features/Search/components/SearchCards/SearchResultCards';
import {PogisDocument, Regulation} from 'types';
import {getEntityListColumns, SearchResult} from './SearchResult';
import {usePogisPageColumn} from 'features/Archive/PogisPageColumns';
import {PogisDocumentsTooltipTranslationProvider} from 'features/Archive/components/PogisDocumentTranslationTooltipProvider';
import {funcMapPogisDocument} from 'features/Archive/PogisDocumentPage';

const entityName = 'PogisDocuments';
const primitiveColumns: string[] = [
	'pogisId',
	'regulationStatus',
	'editor',
	'modelYear',
];
const arrayColumns: string[] = [
	'keywords',
	'markets',
	'standards',
	'associations',
];
const dateColumns: string[] = ['effectiveDate', 'ntDate', 'nfDate'];
const omitColumns: string[] = [];
const quickFilterColumns: string[] = [
	'keywords',
	'markets',
	'standards',
	'editor',
];

type PogisSearchResultProps = {
	currentViewKey: string;
	isResultCardFormat: boolean;
	loading: boolean;
	pogisData: FullTextSearchPogisQuery | undefined;
};

export const PogisSearchResult: React.FC<PogisSearchResultProps> = props => {
	const columnsInfinity = usePogisPageColumn();

	const propsResult = useMemo(() => {
		const colAttributes = {
			getFilterKey: (x: any) => x,
			getFilterLabel: (x: any) => x,
		};

		const columns = getEntityListColumns(
			columnsInfinity,
			primitiveColumns,
			arrayColumns,
			dateColumns,
			omitColumns,
		).map(x => {
			if (arrayColumns.includes(x.key)) {
				return {...x, ...colAttributes};
			}
			if (x.key === 'modelYear') {
				return {
					...x,
					getFilterKey: (x: any) => x,
					getFilterLabel: (x: any) => x.toString().slice(0, 4),
				};
			}
			return x;
		});

		const searchedItems = (
			props.pogisData?.searchPogisDocuments.pogisDocuments || []
		).map(x => funcMapPogisDocument(x as PogisDocument));

		const renderCard = (item: Regulation) => (
			<SearchResultPOGIS key={item.id} item={item} />
		);

		const renderEntityList = (EntityList: JSX.Element) => {
			return (
				<PogisDocumentsTooltipTranslationProvider>
					{EntityList}
				</PogisDocumentsTooltipTranslationProvider>
			);
		};

		return {
			...props,
			entityName,
			searchedItems,
			columns,
			quickFilterColumns,
			renderCard,
			renderEntityList,
		};
	}, [props]);

	return <SearchResult {...propsResult} />;
};
